import React from "react";
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";
import {
  CelebrationOutlined,
  EditNoteOutlined,
  FaceOutlined,
  FilterVintageOutlined,
  Instagram,
  LinkedIn,
  LocalBar,
  MenuBookOutlined,
  PhotoLibraryOutlined,
  Spellcheck,
  VideoLibraryOutlined,
  WorkspacePremiumOutlined,
} from "@mui/icons-material";
import {
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import SceneBox from "components/SceneBox";

export default function ContentHub() {
  const theme = useTheme();
  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");

  return (
    <Box m="1.5rem 2.5rem">
      <FlexBetween>
        <Header title="CONTENT" subtitle="Canva" />
        <Box>
        </Box>
      </FlexBetween>

      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}
      >
        {/* ROW 1 */}
        <SceneBox
          value="Cocktail Menu"
          onClick={() => {
                window.open('https://www.canva.com/design/DAFE-dsoIqM/u39SdafognzkzTMKTird2A/edit?utm_content=DAFE-dsoIqM&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton');
              }}
          icon={
            <MenuBookOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Atelier Certificate"
          onClick={() => {
                window.open('https://www.canva.com/design/DAFzyus-M6I/zN3QvjceAh4b2SMHm5Nr_g/edit');
              }}
          icon={
            <WorkspacePremiumOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
              />
      </Box>
      <FlexBetween marginTop={5}>
        <Header title="" subtitle="GPT"/>
      </FlexBetween>
      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}
      >
        {/* ROW 2 */}
        <SceneBox
                  value="Content Creator"
          onClick={() => {
                window.open('https://chat.openai.com/g/g-5bgGNhFOc-content-creator');
              }}
          icon={
            <Instagram
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
              />
        <SceneBox
                  value="Cocktails Creator"
          onClick={() => {
                window.open('https://chat.openai.com/g/g-RoRMpdSR5-cocktail-maker');
              }}
          icon={
            <LocalBar
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
                  value="Corrector"
          onClick={() => {
                window.open('https://chat.openai.com/g/g-qDJc4qahV-corrector');
              }}
          icon={
            <Spellcheck
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
              />
        <SceneBox
                  value="Blogger"
          onClick={() => {
                window.open('https://chat.openai.com/g/g-W1DqiYT8u-blogger');
              }}
          icon={
            <EditNoteOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
      </Box>
      <FlexBetween marginTop={5}>
        <Header title="" subtitle="Flyers"/>
      </FlexBetween>
      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}
      >
        {/* ROW 3 */}
        <SceneBox
          value="Barman a Domicile"
          onClick={() => {
                window.open('https://drive.google.com/file/d/1QRZokU_sn9zbYueHfy4ApNGwO_RJxPT9/view?usp=drive_link');
              }}
          icon={
            <FaceOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Atelier Cocktails"
          onClick = {() => {
              window.open('https://drive.google.com/file/d/1iC1GClbWxqsQVBObUOqhbvQDMaPvF-UV/view?usp=drive_link');
            }}
          icon={
            <LocalBar
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
              />
        <SceneBox
          value="Weddings"
          onClick={() => {
                window.open('https://drive.google.com/file/d/1NkF6EGPXFOPQ4G3LymdXbqvTim9TQqXW/view?usp=drive_link');
              }}
          icon={
            <CelebrationOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="EVJF"
          onClick = {() => {
              window.open('https://drive.google.com/file/d/1eipQD86cUn9sGc6yu6vKYcoi50FEbRe8/view?usp=drive_link');
            }}
          icon={
            <FilterVintageOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
          </Box>
          
        <FlexBetween marginTop={5}>
            <Header title="" subtitle="Photos & Videos"/>
        </FlexBetween>
        <Box
            mt="20px"
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows="160px"
            gap="20px"
            sx={{
              "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
            }}
        >
        {/* ROW 4 */}
        
        <SceneBox
          value="Media Folder"
          onClick = {() => {
              window.open('https://drive.google.com/drive/folders/13LL68U1IJaL2r3J6acEuMmPf540aDn7d?usp=drive_link');
            }}
          icon={
            <VideoLibraryOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
      </Box>
    </Box>
  );
};